module.exports = __webpack_public_path__ + "img/electronic_no_zone.d93f9d20.svg";